import { useContext } from 'react';
import context, { Context } from 'components/OpenTasksProvider/context';

const useOpenTasks = () => useContext<Context>(context);

export default useOpenTasks;
